export enum BinMode {
  SIZE = 'size',
  NUMBER = 'number',
}

export const MAX_UI_BINS = 25;
export const MIN_NUMBER_OF_BINS = 1;
export const DEFAULT_NUMBER_OF_BINS = 10;
export const MAX_BACKEND_BINS = 1000;
export const DEFAULT_BIN_WIDTH = 1;
export const MIN_SIZE_OF_BIN = 0;
